import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const edittableColumnStringProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // input属性
  maxlength: [String, Number],
  placeholder: String,
})

export type EdittableColumnStringProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnStringProps>>>

export default defineComponent({
  name: 'OEdittableColumnString',
  inheritAttrs: false,
  props: edittableColumnStringProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
